import { useRouter } from 'next/router';
import { MouseEvent, useState } from 'react';

import Avatar from '~components/Avatar';
import Bookmark from '~components/Icon/Bookmark';
import useMyInfoQuery from '~hooks/query/user/useMyInfoQuery';
import useDocumentClick from '~hooks/useDocumentClick';
import useLogout from '~hooks/useLogout';
import useMoveOneIdPage from '~hooks/useMoveOneIdPage';
import useHeaderStore from '~store/header';
import { getVisitedMypageToStorage, setVisitedMypageToStorage } from '~utils/browser/visitedMypage';

import * as S from './style';

export default function SessionMenuForDesktop() {
  const router = useRouter();
  const { data: myInfoData, isActiveUser, status, fetchStatus } = useMyInfoQuery();
  const { setIsModalBookmarksOpen } = useHeaderStore();
  const [visitedMypage, setVisitedMypage] = useState(getVisitedMypageToStorage());
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>();
  const moveOneIdPage = useMoveOneIdPage();
  const handleLogout = useLogout();

  useDocumentClick(() => setIsOpenMenu(false));

  const handleClickAvatar = (e: MouseEvent) => {
    e.stopPropagation();
    setIsOpenMenu((prevState) => !prevState);
  };

  const handleClickMypage = () => {
    setVisitedMypage(true);
    setVisitedMypageToStorage();
    router.push('/mypage/career');
  };

  if (status === 'loading' && fetchStatus !== 'idle') {
    return null;
  }

  return (
    <S.Wrapper>
      {isActiveUser ? (
        <>
          <S.ButtonBookmark
            onClick={() => setIsModalBookmarksOpen(true)}
            data-attribute-id='gnb'
            data-gnb-kind='bookmark'>
            <Bookmark />
          </S.ButtonBookmark>
          <S.AvatarWrapper>
            <Avatar
              data-attribute-id='gnb'
              data-gnb-kind='profile'
              isNew={!visitedMypage}
              onClick={handleClickAvatar}
              thumbnail={myInfoData?.profileUrl}
            />
            {isOpenMenu && (
              <S.Menu>
                <S.MenuItem
                  data-attribute-id='gnb'
                  data-gnb-kind='profileMypage'
                  isNew
                  onClick={handleClickMypage}>
                  <span>마이페이지</span>
                </S.MenuItem>
                <S.MenuItem
                  data-attribute-id='gnb'
                  data-gnb-kind='profileLogout'
                  onClick={() => handleLogout({ reload: true })}>
                  <span>로그아웃</span>
                </S.MenuItem>
              </S.Menu>
            )}
          </S.AvatarWrapper>
        </>
      ) : (
        <S.ButtonLogin
          data-attribute-id='gnb'
          data-gnb-kind='signupLogin'
          onClick={() => {
            moveOneIdPage();
          }}>
          로그인/회원가입
        </S.ButtonLogin>
      )}
    </S.Wrapper>
  );
}
